import { Link } from 'react-router-dom'

interface LogoProps {
  className?: string
  size?: number
  variant?: 'icon' | 'full'
}

const Logo = ({ className = "", size = 72, variant = 'icon' }: LogoProps) => {
  return (
    <Link to="/" className={`flex items-center ${className} cursor-pointer hover:opacity-80 transition-opacity`}>
      {variant === 'full' ? (
        <img
          src="/logos/azrefy-full-logo.svg"
          alt="Azrefy"
          className="h-32 w-auto"
        />
      ) : (
        <div className="flex items-center gap-3">
          <img
            src="/logos/azrefy-icon.svg"
            alt="Azrefy Icon"
            style={{ width: size, height: size }}
            className="rounded-xl"
          />
          <span className="text-3xl font-bold text-white tracking-tight">
            Azref<span className="text-gradient">y</span>
          </span>
        </div>
      )}
    </Link>
  )
}

export default Logo
